/* tslint:disable */
/* eslint-disable */
/**
 * (S-CAPI-DDMS)図面書類管理サービス向け
 * 図面書類管理サービス向けAPI ※ API Management経由でアクセスする場合はRequestHeaderにxgrab-api-key(API Managementのサブスクリプションキー)が必要となるが、本資料としては省略している 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: 1234567890abcd@co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { DDMSCreatorModel } from './ddmscreator-model';

/**
 * ボックス承認履歴情報
 * @export
 * @interface BoxApprovalHistoryModel
 */
export interface BoxApprovalHistoryModel {
    /**
     * ボックス承認履歴ID
     * @type {string}
     * @memberof BoxApprovalHistoryModel
     */
    box_approval_history_id?: string;
    /**
     * 承認区分 - UNAPPROVED:未承認 - APPROVING:承認中 - PARTIAL_APPROVAL:部分承認 - APPROVED:承認済み - DENIAL:否認 
     * @type {string}
     * @memberof BoxApprovalHistoryModel
     */
    approval_history_type?: BoxApprovalHistoryModelApprovalHistoryTypeEnum;
    /**
     * 承認変更日時
     * @type {string}
     * @memberof BoxApprovalHistoryModel
     */
    approval_change_at?: string;
    /**
     * 承認コメント
     * @type {string}
     * @memberof BoxApprovalHistoryModel
     */
    approval_comment?: string;
    /**
     * 
     * @type {DDMSCreatorModel}
     * @memberof BoxApprovalHistoryModel
     */
    creator?: DDMSCreatorModel;
}

/**
    * @export
    * @enum {string}
    */
export enum BoxApprovalHistoryModelApprovalHistoryTypeEnum {
    Unapproved = 'UNAPPROVED',
    Approving = 'APPROVING',
    PartialApproval = 'PARTIAL_APPROVAL',
    Approved = 'APPROVED',
    Denial = 'DENIAL'
}



